import { loadStripe } from '@stripe/stripe-js';

// Stripe publishable key (test mode)
const stripePublishableKey = 'pk_test_51NiT8CEdfvYdrt6Zhrz0sBLSLdrfPOOXZ6VqxokcQdntHrfTL233mXApkm0YCvI56K1s7EzRxczSRkNU5EtovS900ajD31hHn';

// Initialize Stripe
export const stripePromise = loadStripe(stripePublishableKey);

// Price IDs for subscription plans
export const PRICE_IDS = {
  pro: 'price_1ScfjJEdfvYdrt6ZKvpzHl1D',
  enterprise: 'price_1ScfjyEdfvYdrt6ZmUzqOh9M',
} as const;

// Plan details for UI
export const PLANS = {
  free: {
    name: 'Free',
    price: 0,
    priceId: null,
    features: [
      '3 reports per month',
      '8 compliance alert types',
      'Staff & client views',
      'Basic financial summary',
      'Google Drive import',
      'Report history & trends',
    ],
    limitations: [
      'No PDF/audit exports',
      'No payroll estimation',
      'No webhooks',
    ],
  },
  pro: {
    name: 'Pro',
    price: 79,
    priceId: PRICE_IDS.pro,
    features: [
      'Unlimited reports',
      'PDF & audit report exports',
      'Revenue leakage detection',
      'Missed revenue analysis',
      'Bi-weekly payroll estimation',
      'Staff pay rate management',
      'Webhook integrations',
      'Custom alert thresholds',
      'Program billing limits',
    ],
    limitations: [
      'No multi-location',
      'No team accounts',
      'No API access',
    ],
  },
  enterprise: {
    name: 'Enterprise',
    price: 199,
    priceId: PRICE_IDS.enterprise,
    features: [
      'Everything in Pro, plus:',
      'Multi-location management',
      'Team accounts (up to 10 users)',
      'Role-based access control',
      'Full REST API access',
      'Location-based filtering',
      'Provider number mapping',
      'Priority support',
    ],
    limitations: [],
  },
} as const;

export type PlanType = keyof typeof PLANS;
